export enum FocusMessageSafetyChoice {
  SAFE = 'Safe',
  UNSAFE = 'Unsafe',
}

export enum MessageStatus {
  READ = 'Read',
  DELIVERED = 'Delivered',
  SENT = 'Sent',
}

export enum MessageReceiverType {
  GROUP = 'Group',
  USER = 'User',
  FOCUS = 'focus',
}

/**
 * Represents type of chats
 */
export enum ChatType {
  GROUP = 'group',
  PRIVATE = 'pair',
  FOCUS = 'focus',
}

export enum StoreStatus {
  PENDING = 'pending',
  DELETED = 'deleted',
}

/**
 * Represents message categories
 */
export const MessageCategory = Object.freeze({
  WELCOME: 'Welcome Prompt',
  INTRO: 'Intro Prompt',
  PAIR: 'Pair Prompt',
  GROUP: 'Group Prompt',
  PRIVATE: 'Private Prompt',
  QUOTE: 'Quote Prompt',
  MENTOR: 'Mentor Prompt',
  MENTEE: 'Mentee Prompt',
  PAIR_CONNECTION: 'Pair Connection Prompt From Admin',
});

export const MessageType = Object.freeze({
  WELCOME_MESSAGE: 'Welcome Message',
  INTRO_MESSAGE: 'IntroMessage',
  TEXT: 'Text',
  MEDIA: 'Media',
  PROJECT: 'Project',
  FILE: 'File',
  TRAINING: 'Training',
  CONTENT: 'Content',
  LINK: 'Link',
  QUOTE: 'Quote',
  ANNOUNCEMENT: 'Announcement',
  PRE_MATCH_ANNOUNCEMENT: 'Pre-Match Announcement',
  OPEN_RESPONSE_PROMPT: 'Open Response Prompt',
});

/**
 * Roles
 */
export const ROLE = Object.freeze({
  I_SUPER_ADMIN: 'Super Admin',
  I_LOCAL_ADMIN: 'IM Local Admin',
  P_SUPER_ADMIN: 'Partner Super Admin',
  P_LOCAL_ADMIN: 'Partner Local Admin',
  MENTOR: 'Mentor',
  MENTEE: 'Mentee',
});

/**
 * Available prompt type options
 */
export const PROMPT_TYPE_OPTIONS = Object.freeze({
  MULTI_CHOICE: { label: 'Multi-Choice', value: 'Multi-Choice' },
  OPEN_RESPONSE: { label: 'Open Response', value: 'Open-Response' },
  NUDGE: { label: 'Nudge', value: 'Nudge' },
  PAIR_CONNECTION: { label: 'Pair Connection', value: 'Pair-Connection' },
});

/**
 * Alternative message for all prompt types
 */
export const ALTERNATIVE_MESSAGE = Object.freeze({
  ALTERNATIVE_MESSAGE: { label: 'Alternative Message', value: 'Alternative Message' },
});

/**
 * Prompt recipient response filter types
 */
export const PROMPT_RECIPIENT_RESPONSE_FILTER_TYPE = Object.freeze({
  ALL_USERS: 'All-Users',
  RESPONDERS: 'Responders',
  NON_RESPONDERS: 'Non-Responders',
});

/**
 * Prompts textarea placeholders
 */
export const PROMPTS_TEXTAREA_PLACEHOLDER = Object.freeze({
  NUDGE:
    'Keep it short, action-oriented, and positive (e.g., ‘Reminder: Please complete your weekly check-in by Friday.’)',
  OPEN_RESPONSE: 'Ask an open-ended question to encourage detailed responses...',
  PAIR_CONNECTION: 'Write a prompt to spark meaningful dialogue...',
  MULTI_CHOICE: "Ask a clear, simple question to engage your audience (e.g., 'What is your top priority this week?')",
  ALTERNATIVE_MESSAGE: 'Write an alternative message here.',
});

export const ALLOWED_DOMAINS = Object.freeze([
  'imentor.org',
  'cms.imentor.org',
  'pilot.imentor.org',
  'imentordev.org',
  'staging.imentor.org',
  'cms.imentordev.org',
  'cms.staging.imentor.org',
  'dev.imentor.org',
  'cms.dev.imentordev.org',
  'cms.dev.staging.imentor.org',
]);

/**
 * Messages - Team Inbox and Pair Chats
 */
export const TABKEY = Object.freeze({
  TEAM_INBOX: 'team-inbox',
  PAIR_CHATS: 'pair-chats',
});

/**
 * Custom fields
 */
export const CUSTOM_FIELDS_SUBTITLE =
  "Custom Fields are additional data fields you can create to capture information not collected by the platform (e.g., 'Major'). These fields can be applied to mentors, mentees, or admins and can be used to create groups or included in exports. ";
export const CUSTOM_FIELDS_ADD_BTN_TEXT = 'Add New Field';
export const NO_CUSTOM_FIELDS_MESSAGE = 'Add your first custom field by selecting “Add New Field” below';
export const CUSTOM_FIELDS_PREFERENCES_NOTE =
  'Change the order of the columns in the table, or choose to show or hide a field. Drag and drop to change the order of the columns.';

/**
 * Messages - Team Inbox and Pair Chats
 */
export const MESSAGE_TABKEY = Object.freeze({
  TEAM_INBOX: 'team-inbox',
  PAIR_CHATS: 'pair-chats',
});

/**
 * Prompts - Insert template fields
 */

/**
 * Mentee FRL (Free or Reduced Lunch) answers. Labels and values match the backend and the web
 * and mobile apps exactly.
 */
export const FRL_QUESTION_LABEL = 'Do you qualify for Free or Reduced lunch at your school?';
export const FRL_OPTIONS = Object.freeze(
  ['Yes', 'No', "I don't know", 'Not applicable'].map(answer => ({ label: answer, value: answer }))
);
